<template>
    <modal name="product-write-modal" class="judge-info-modal"
           :width="650"
           :height="'auto'"
           @before-open="handlerBeforeOpen"
           @before-close="handlerBeforeClose"
    >
        <div class="modal_title">상품등록</div>
        <div class="pl30 pr30 pb30">
                <point-write-component :point-type="pointType" :pointKey="pointKey"></point-write-component>
            <div class="btn_box text-center mt20">
                <el-button class="reg_btn_out" @click="saveProduct()">상품등록</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import util from "@/mixins/util";
import PointWriteComponent from "@/components/point/PointWriteComponent";
import EventBus from "@/utils/event-bus";
export default {
    name: "ProductWriteModal",
    mixins: [],
    components: {PointWriteComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            pointType:'createProduct',
            pointKey:0,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
            let key = event.params?.pointKey
            if(!util.isEmpty(key)){
                this.pointKey = key
                this.pointType = 'updateProduct'
            }else {
                this.pointType='createProduct'
                    this.pointKey=0
            }
        },
        handlerBeforeClose() {
        },
        closeModal() {
            this.$modal.hide('product-write-modal')
        },
        saveProduct(){
          EventBus.$emit('writePoint')
        }

    },
    watch: {},
}
</script>

<style scoped>

</style>
